module.exports = __webpack_public_path__ + "img/icon_buzz_lines_left_white.10c5613f.svg";